<template>
  <div>
    <div
      class="d-flex flex-column pt-12 bgi-size-cover bgi-no-repeat rounded-top"
      :style="{ backgroundImage: `url(${backgroundImage})` }"
    >
      <h4 class="d-flex flex-center rounded-top">
        <span class="text-white">Notifications</span>
        <span
          class="
            btn btn-text btn-success btn-sm
            font-weight-bold
            btn-font-md
            ml-2
          "
        >
          {{ currentNotifications.length }}
        </span>
      </h4>

      <ul
        class="
          nav
          nav-bold
          nav-tabs
          nav-tabs-line
          nav-tabs-line-3x
          nav-tabs-line-transparent-white
          nav-tabs-line-active-border-success
          mt-3
          px-8
        "
        role="tablist"
      >
        <li class="nav-item">
          <a
            v-on:click="setActiveTab"
            data-tab="0"
            class="nav-link active"
            data-toggle="tab"
            href="#"
            role="tab"
          >
            Abonnements
          </a>
        </li>
        <!-- <li class="nav-item">
          <a
            v-on:click="setActiveTab"
            data-tab="1"
            class="nav-link"
            data-toggle="tab"
            href="#"
            role="tab"
          >
            Events
          </a>
        </li> -->
        <!-- <li class="nav-item">
          <a
            v-on:click="setActiveTab"
            data-tab="2"
            class="nav-link"
            data-toggle="tab"
            href="#"
            role="tab"
          >
            Logs
          </a>
        </li> -->
      </ul>
    </div>

    <b-tabs class="hide-tabs" v-model="tabIndex">
      <b-tab active>
        <perfect-scrollbar
          class="navi navi-hover scroll my-4"
          style="max-height: 40vh; position: relative"
          v-if="currentNotifications.length > 0"
        >
          <template v-for="(item, i) in currentNotifications">
            <a
              href="javascript:;"
              @click="selectNotification(item)"
              class="navi-item"
              v-bind:key="i"
            >
              <div class="navi-link">
                <div class="navi-icon mr-2">
                  <i v-bind:class="item.icon"></i>
                </div>
                <div class="navi-text">
                  <div  class="font-weight-bold">
                    Abonnement: {{ item.reference }}
                  </div>
                         
                  <div class="text-muted">
                    <timeago :datetime="item.date" :auto-update="60"></timeago>
                  </div>
                </div>
              </div>
            </a>
          </template>
        </perfect-scrollbar>

        <div
          v-if="currentNotifications.length == 0"
          class="d-flex flex-center text-center text-muted min-h-200px"
        >
          Aucune notifications.
        </div>
      </b-tab>
      <b-tab>
        <perfect-scrollbar
          class="scroll pr-7 mr-n7"
          style="max-height: 40vh; position: relative"
        >
          <template v-for="(item, i) in list1">
            <!--begin::Item-->
            <div class="d-flex align-items-center mb-6" v-bind:key="i">
              <!--begin::Symbol-->
              <div
                class="symbol symbol-40 mr-5"
                v-bind:class="`symbol-light-${item.color}`"
              >
                <span class="symbol-label">
                  <span
                    class="svg-icon svg-icon-lg"
                    v-bind:class="`svg-icon-${item.color}`"
                  >
                    <!--begin::Svg Icon-->
                    <inline-svg :src="item.svg" />
                    <!--end::Svg Icon-->
                  </span>
                </span>
              </div>
              <!--end::Symbol-->
              <!--begin::Text-->
              <div class="d-flex flex-column font-weight-bold">
                <a
                  href="#"
                  class="text-dark text-hover-primary mb-1 font-size-lg"
                >
                  {{ item.title }}
                </a>
                <span class="text-muted">
                  {{ item.desc }}
                </span>
              </div>
              <!--end::Text-->
            </div>
            <!--end::Item-->
          </template>
        </perfect-scrollbar>
      </b-tab>
      <b-tab>
        <div class="d-flex flex-center text-center text-muted min-h-200px">
          Aucune notifications.
        </div>
      </b-tab>
    </b-tabs>
  </div>
</template>

<style lang="scss">
/* hide default vue-bootstrap tab links */
.hide-tabs > div:not(.tab-content) {
  display: none;
}
</style>

<script>
import { mapGetters } from "vuex";
import {
  SELECT_NOTIFICATION,
  PUSH_NOTIFICATION,
} from "../../../../core/services/store/notification.module";

import RequestsService from "../../../../services/requests.service";
export default {
  name: "KTDropdownNotification",
  data() {
    return {
      tabIndex: 0,
      list1: [],
      list2: [],
    };
  },
  created() {
    this.$availabilityHub.$on("request-notify", this.addNotification);
  },
  beforeDestroy() {
    this.$availabilityHub.$off("request-notify", this.addNotification);
  },
  methods: {
    addNotification(notif) {
      this.$store.dispatch(PUSH_NOTIFICATION, notif);
      RequestsService.getRequestCount();
    },
    selectNotification(notif) {
      this.$store.dispatch(SELECT_NOTIFICATION, notif.requestGuid);
      this.$router.push({
        name: "requests-detail",
        params: { guid: notif.requestGuid },
      });

      // const routeData = this.$router.resolve({
      //   name: "requests-detail",
      //   params: { guid: notif.requestPharmacyGuid },
      // });
      // window.open(routeData.href, "_blank");
    },
    setActiveTab(event) {
      const tab = event.target.closest('[role="tablist"]');
      const links = tab.querySelectorAll(".nav-link");
      // remove active tab links
      for (let i = 0; i < links.length; i++) {
        links[i].classList.remove("active");
      }

      // set clicked tab index to bootstrap tab
      this.tabIndex = parseInt(event.target.getAttribute("data-tab"));

      // set current active tab
      event.target.classList.add("active");
    },
  },
  computed: {
    ...mapGetters(["currentNotifications"]),
    backgroundImage() {
      return process.env.BASE_URL + "media/misc/bg-1.jpg";
    },
  },
};
</script>
